import React from 'react';

const CheckoutContext = React.createContext();

export const { Provider, Consumer } = CheckoutContext;
export default CheckoutContext;
